define('editor/edit/contexts/preview',['jquery', 'plugins/dialog', 'knockout', 'durandal/system', 'durandal/composition', 'durandal/activator'], function ($, dialog, ko, system, composition, activator) {
    var viewmodel = function () {
        var self = this;

        self.block = null;
        self.host = null;
        self.content = ko.observable();
        self.fadeIn = "inner animated fadeInRight";
        self.fadeOut = "inner animated fadeOutRight";
        self.removeDelay = 1000;
        self.theDialog = null;

        self.activate = function (editorMap) {
            var body = $('body');
            
            self.editorMap = editorMap;
            self.editorMapId = editorMap.id;

            self.block = $('<div id="mapforge-custom-dialog"></div>').appendTo(body);
            self.host = $('<div class="' + self.fadeIn + '"></div>').appendTo(self.block);
        };

        self.dialogClose = function () {
            $('.tab-button.layers').click();
        };

        self.compositionComplete = function () {
            system.acquire('editor/render/iframe')
                .then(function (instance) {
                    var dialogActivator = activator.create(),
                        moduleInstance = system.resolveObject(instance),
                        activationData = [self.editorMap, self.dialogClose];

                    dialogActivator.activateItem(moduleInstance, activationData)
                        .then(function () {
                            var settings = {
                                model: moduleInstance,
                                activate: false,
                                transition: false
                            };
                            
                            self.theDialog = {
                                close: function () {
                                    dialogActivator.deactivateItem(moduleInstance, true);
                                }
                            };

                            composition.compose(self.host.get(0), settings);
                        });
                });
        };

        self.deactivate = function () {
            self.host.attr('class', self.fadeOut);
            
            setTimeout(function () {
                self.theDialog.close();
                self.host.remove();
                self.block.remove();
            }, self.removeDelay);
        };
    };

    return viewmodel;
});

